import ApliClient from '../factory/ww-api';

const updateSettingsAsync = async (
    publicKey,
    clientUrl,
    clientKey,
    ownerId,
    brokerId,
    brokerName,
    blipToken,
    tenantId
) => {
    const api = ApliClient;
    const config = {
        headers: {
            Authorization: publicKey
        }
    };
    const { data } = await api.post(
        'activeCampaign2/settings',
        {
            url: clientUrl,
            key: clientKey,
            publicKey,
            ownerId: ownerId || '',
            brokerId: brokerId || '',
            brokerName: brokerName || '',
            blipToken: blipToken || '',
            tenantId: tenantId || ''
        },
        config
    );
    return data;
};

export { updateSettingsAsync };
